import { useContext } from 'react';
import { PatrimonialDependenceContext } from 'contexts/patrimonialDependenceContext/PatrimonialDependenceContext';

export const usePatrimonialDependenceContext = () => {
	return useContext(PatrimonialDependenceContext);
};
